var _defs, _rect, _g, _polygon, _polygon2, _polyline, _line, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationToilettes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "r\\xE9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3001.22 3000.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-63,.cls-64{fill:none;}.cls-2{fill:#d0d9d9;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-7,.cls-8,.cls-9{stroke:#594b45;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-63,.cls-64,.cls-66,.cls-67,.cls-68,.cls-7,.cls-70,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_157);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_157-2);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_157-3);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_157-4);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_157-5);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_157-6);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_157-7);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_157-8);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_157-9);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_157-10);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_157-11);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_157-12);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_157-13);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_157-14);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_157-15);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_157-16);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_157-17);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_157-18);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_157-19);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_157-20);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_157-21);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_157-22);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_157-23);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_157-24);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_157-25);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_157-26);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_157-27);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_157-28);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_157-29);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_157-30);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_157-31);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_157-32);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_157-33);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_157-34);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_157-35);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_157-36);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_157-37);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_157-38);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_157-39);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_157-40);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_157-41);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_157-42);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_157-43);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_157-44);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_157-45);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_157-46);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_157-47);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_157-48);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_157-49);}.cls-52{fill:url(#D\xE9grad\xE9_sans_nom_157-50);}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_157-51);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_157-52);}.cls-55{fill:url(#D\xE9grad\xE9_sans_nom_157-53);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_157-54);}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_157-55);}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_157-56);}.cls-59{fill:url(#D\xE9grad\xE9_sans_nom_157-57);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_157-58);}.cls-61{fill:url(#D\xE9grad\xE9_sans_nom_358);}.cls-62{fill:url(#D\xE9grad\xE9_sans_nom_369);}.cls-63,.cls-64,.cls-66,.cls-67,.cls-68,.cls-70{stroke:#000;}.cls-63,.cls-66{stroke-width:3px;}.cls-65{clip-path:url(#clip-path);}.cls-66{fill:url(#D\xE9grad\xE9_sans_nom_22);}.cls-67{fill:url(#D\xE9grad\xE9_sans_nom_22-2);}.cls-68{fill:url(#D\xE9grad\xE9_sans_nom_22-3);}.cls-69{fill:url(#D\xE9grad\xE9_sans_nom_42);}.cls-70{fill:url(#D\xE9grad\xE9_sans_nom_42-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157",
    x1: 1509.5,
    y1: 2724.18,
    x2: 1509.5,
    y2: 2632.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#614533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a07860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a77d64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b2866b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c39376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cf9b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c79678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ba8c70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a77e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b1856b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cf9c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c89678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bd8d70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ac8065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b5a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70513e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-2",
    x1: 709.5,
    y1: 2724.18,
    x2: 709.5,
    y2: 2632.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-3",
    x1: 2854.5,
    y1: 2724.18,
    x2: 2854.5,
    y2: 2632.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-4",
    x1: 2309.5,
    y1: 2724.18,
    x2: 2309.5,
    y2: 2632.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-5",
    x1: 1937.5,
    y1: 2630.1,
    x2: 1937.5,
    y2: 2538.16,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-6",
    x1: 1137.5,
    y1: 2630.1,
    x2: 1137.5,
    y2: 2538.16,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-7",
    x1: 369,
    y1: 2630.1,
    x2: 369,
    y2: 2538.16,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-8",
    x1: 2668.5,
    y1: 2630.1,
    x2: 2668.5,
    y2: 2538.16,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-9",
    x1: 2070.26,
    y1: 2538.16,
    x2: 2070.26,
    y2: 2446.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-10",
    x1: 1369.9,
    y1: 2538.16,
    x2: 1369.9,
    y2: 2446.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-11",
    x1: 697.11,
    y1: 2538.16,
    x2: 697.11,
    y2: 2446.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-12",
    x1: 187.56,
    y1: 2538.16,
    x2: 187.56,
    y2: 2446.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-13",
    x1: 2710.22,
    y1: 2538.16,
    x2: 2710.22,
    y2: 2446.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-14",
    x1: 155,
    y1: 2724.18,
    x2: 155,
    y2: 2632.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-15",
    x1: 1137.5,
    y1: 2816.12,
    x2: 1137.5,
    y2: 2724.18,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-16",
    x1: 1937.5,
    y1: 2816.12,
    x2: 1937.5,
    y2: 2724.18,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-17",
    x1: 369,
    y1: 2816.12,
    x2: 369,
    y2: 2724.18,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-18",
    x1: 187.5,
    y1: 2908.06,
    x2: 187.5,
    y2: 2816.12,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-19",
    x1: 773.5,
    y1: 2908.06,
    x2: 773.5,
    y2: 2816.12,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-20",
    x1: 1573.5,
    y1: 2908.06,
    x2: 1573.5,
    y2: 2816.12,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-21",
    x1: 2373.5,
    y1: 2908.06,
    x2: 2373.5,
    y2: 2816.12,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-22",
    x1: 2668.5,
    y1: 2816.12,
    x2: 2668.5,
    y2: 2724.18,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-23",
    x1: 405.5,
    y1: 3000,
    x2: 405.5,
    y2: 2908.06,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-24",
    x1: 1209.5,
    y1: 3000,
    x2: 1209.5,
    y2: 2908.06,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-25",
    x1: 2009.5,
    y1: 3000,
    x2: 2009.5,
    y2: 2908.06,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-26",
    x1: 2704.5,
    y1: 3000,
    x2: 2704.5,
    y2: 2908.06,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-27",
    x1: 2886.5,
    y1: 2908.06,
    x2: 2886.5,
    y2: 2816.12,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-28",
    x1: 1509.5,
    y1: 2170.4,
    x2: 1509.5,
    y2: 2078.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-29",
    x1: 709.5,
    y1: 2170.4,
    x2: 709.5,
    y2: 2078.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-30",
    x1: 2854.5,
    y1: 2170.4,
    x2: 2854.5,
    y2: 2078.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-31",
    x1: 2309.5,
    y1: 2170.4,
    x2: 2309.5,
    y2: 2078.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-32",
    x1: 1937.5,
    y1: 2076.32,
    x2: 1937.5,
    y2: 1984.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-33",
    x1: 1137.5,
    y1: 2076.32,
    x2: 1137.5,
    y2: 1984.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-34",
    x1: 369,
    y1: 2076.32,
    x2: 369,
    y2: 1984.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-35",
    x1: 2668.5,
    y1: 2076.32,
    x2: 2668.5,
    y2: 1984.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-36",
    x1: 2070.26,
    y1: 1984.38,
    x2: 2070.26,
    y2: 1892.44,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-37",
    x1: 1369.9,
    y1: 1984.38,
    x2: 1369.9,
    y2: 1892.44,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-38",
    x1: 697.11,
    y1: 1984.38,
    x2: 697.11,
    y2: 1892.44,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-39",
    x1: 187.56,
    y1: 1984.38,
    x2: 187.56,
    y2: 1892.44,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-40",
    x1: 2710.22,
    y1: 1984.38,
    x2: 2710.22,
    y2: 1892.44,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-41",
    x1: 155,
    y1: 2170.4,
    x2: 155,
    y2: 2078.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-42",
    x1: 1137.5,
    y1: 2262.34,
    x2: 1137.5,
    y2: 2170.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-43",
    x1: 1937.5,
    y1: 2262.34,
    x2: 1937.5,
    y2: 2170.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-44",
    x1: 369,
    y1: 2262.34,
    x2: 369,
    y2: 2170.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-45",
    x1: 187.5,
    y1: 2354.28,
    x2: 187.5,
    y2: 2262.34,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-46",
    x1: 773.5,
    y1: 2354.28,
    x2: 773.5,
    y2: 2262.34,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-47",
    x1: 1573.5,
    y1: 2354.28,
    x2: 1573.5,
    y2: 2262.34,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-48",
    x1: 2373.5,
    y1: 2354.28,
    x2: 2373.5,
    y2: 2262.34,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-49",
    x1: 2668.5,
    y1: 2262.34,
    x2: 2668.5,
    y2: 2170.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-50",
    x1: 405.5,
    y1: 2446.22,
    x2: 405.5,
    y2: 2354.28,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-51",
    x1: 1209.5,
    y1: 2446.22,
    x2: 1209.5,
    y2: 2354.28,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-52",
    x1: 2009.5,
    y1: 2446.22,
    x2: 2009.5,
    y2: 2354.28,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-53",
    x1: 2704.5,
    y1: 2446.22,
    x2: 2704.5,
    y2: 2354.28,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-54",
    x1: 2886.5,
    y1: 2354.28,
    x2: 2886.5,
    y2: 2262.34,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-55",
    x1: 405.5,
    y1: 1892.44,
    x2: 405.5,
    y2: 1800.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-56",
    x1: 1209.5,
    y1: 1892.44,
    x2: 1209.5,
    y2: 1800.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-57",
    x1: 2009.5,
    y1: 1892.44,
    x2: 2009.5,
    y2: 1800.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-58",
    x1: 2704.5,
    y1: 1892.44,
    x2: 2704.5,
    y2: 1800.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_358",
    x1: 1500,
    x2: 1500,
    y2: 2316.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83c4bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#295848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_369",
    x1: 2816.34,
    y1: 0,
    x2: 2816.34,
    y2: 2316.18,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_358"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2838.8,555.79s-150.78-5.62-170-4.82c-2.4-9.62-10.42-19.24-10.42-19.24s-48.12-1.61-55.34,1.6-13.63,16-13.63,16-85-4.81-113.89-6.42c-15.24-19.24-29.67-26.46-45.71-16.84s-23.26,25.67-44.11,65.77c-97.85,172.43-166,643.2-166,643.2l-23.25,20.05s-64.16-16.84-107.47-21.65-197.29-10.43-235.79-10.43-159.6,8.82-254.23,32.88-114.69,54.54-120.3,70.58,9.62,28.87,9.62,28.87-22.46,60.15,40.1,192.48S1708,1705.05,1708,1705.05l-24.06,339.25c12.83,26.46,57.74,58.54,57.74,58.54l44.11,16.85,637.59,19.24,87.42,28.07,48.12-31.27,43.31-676.89h29.67l141.15-40.1,30.48-62.56.8-20-8.82-4.81Zm-451.13,731.82h-32.08c6.42-18.45,26.47-84.21,46.52-164.41-1.6,20.85-8.82,131.53-8.82,131.53l15.23,19.25Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22",
    x1: 2158.08,
    y1: 2167,
    x2: 2158.08,
    y2: 521.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8adad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b8bcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#cfd3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#eaeeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-2",
    x1: 1751.19,
    y1: 2103.25,
    x2: 1751.19,
    y2: 1715.48,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-3",
    x1: 1792.49,
    y1: 2103.25,
    x2: 1792.49,
    y2: 1719.09,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_42",
    x1: 1933.13,
    y1: 1727.07,
    x2: 1933.13,
    y2: 1541.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8adad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b9bebe",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e5e9ea",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf1f2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_42-2",
    x1: 1892.84,
    y1: 1386.26,
    x2: 1892.84,
    y2: 1287.61,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_42"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "r\xE9paration toilettes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 1753.97,
    width: 3000,
    height: 1246.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parquet"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1109.5,
    y: 2632.24,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 309.5,
    y: 2632.24,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2709.5,
    y: 2632.24,
    width: 290,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1909.5,
    y: 2632.24,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1537.5,
    y: 2538.16,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 737.5,
    y: 2538.16,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.5,
    y: 2538.16,
    width: 737,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2337.5,
    y: 2538.16,
    width: 662,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1720.08,
    y: 2446.22,
    width: 700.37,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1019.71,
    y: 2446.22,
    width: 700.37,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 374.5,
    y: 2446.22,
    width: 645.21,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0.5,
    y: 2446.22,
    width: 374.12,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2420.45,
    y: 2446.22,
    width: 579.55,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 0.5,
    y: 2632.24,
    width: 309,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 737.5,
    y: 2724.18,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1537.5,
    y: 2724.18,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0.5,
    y: 2724.18,
    width: 737,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 0.5,
    y: 2816.12,
    width: 374,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 373.5,
    y: 2816.12,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1173.5,
    y: 2816.12,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1973.5,
    y: 2816.12,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2337.5,
    y: 2724.18,
    width: 662,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 0.5,
    y: 2908.06,
    width: 810,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 809.5,
    y: 2908.06,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1609.5,
    y: 2908.06,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2409.5,
    y: 2908.06,
    width: 590,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 2773.5,
    y: 2816.12,
    width: 226,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1109.5,
    y: 2078.46,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 309.5,
    y: 2078.46,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2709.5,
    y: 2078.46,
    width: 290,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1909.5,
    y: 2078.46,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1537.5,
    y: 1984.38,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 737.5,
    y: 1984.38,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 0.5,
    y: 1984.38,
    width: 737,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 2337.5,
    y: 1984.38,
    width: 662,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1720.08,
    y: 1892.44,
    width: 700.37,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1019.71,
    y: 1892.44,
    width: 700.37,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 374.5,
    y: 1892.44,
    width: 645.21,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 0.5,
    y: 1892.44,
    width: 374.12,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 2420.45,
    y: 1892.44,
    width: 579.55,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 0.5,
    y: 2078.46,
    width: 309,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 737.5,
    y: 2170.4,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1537.5,
    y: 2170.4,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 0.5,
    y: 2170.4,
    width: 737,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 0.5,
    y: 2262.34,
    width: 374,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 373.5,
    y: 2262.34,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1173.5,
    y: 2262.34,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1973.5,
    y: 2262.34,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 2337.5,
    y: 2170.4,
    width: 662,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 0.5,
    y: 2354.28,
    width: 810,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 809.5,
    y: 2354.28,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1609.5,
    y: 2354.28,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2409.5,
    y: 2354.28,
    width: 590,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2773.5,
    y: 2262.34,
    width: 226,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 0.5,
    y: 1800.5,
    width: 810,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 809.5,
    y: 1800.5,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1609.5,
    y: 1800.5,
    width: 800,
    height: 91.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2409.5,
    y: 1800.5,
    width: 590,
    height: 91.94
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "0 1800.49 2632.68 1800.49 3000 2316.18 3000 0 0 0 0 1800.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "3000 2316.18 2632.68 1800.49 2632.68 0 3000 0 3000 2316.18"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-63",
    points: "0 1800 2632.5 1800.5 3000 2316.18 2632.68 1800.49 594 1800.49"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 2632.28,
    y1: 1800.09,
    x2: 2633.09,
    y2: 0.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "toilettes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2838.8,555.79s-150.78-5.62-170-4.82c-2.4-9.62-10.42-19.24-10.42-19.24s-48.12-1.61-55.34,1.6-13.63,16-13.63,16-85-4.81-113.89-6.42c-15.24-19.24-29.67-26.46-45.71-16.84s-23.26,25.67-44.11,65.77c-97.85,172.43-166,643.2-166,643.2l-23.25,20.05s-64.16-16.84-107.47-21.65-197.29-10.43-235.79-10.43-159.6,8.82-254.23,32.88-114.69,54.54-120.3,70.58,9.62,28.87,9.62,28.87-22.46,60.15,40.1,192.48S1708,1705.05,1708,1705.05l-24.06,339.25c12.83,26.46,57.74,58.54,57.74,58.54l44.11,16.85,637.59,19.24,87.42,28.07,48.12-31.27,43.31-676.89h29.67l141.15-40.1,30.48-62.56.8-20-8.82-4.81Zm-451.13,731.82h-32.08c6.42-18.45,26.47-84.21,46.52-164.41-1.6,20.85-8.82,131.53-8.82,131.53l15.23,19.25Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1708,1705.05s63.82,17.92,171.63,20",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 1761.12,
    y1: 1715.48,
    x2: 1741.26,
    y2: 2103.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 1788.38,
    y1: 1719.09,
    x2: 1796.6,
    y2: 2103.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2201.61,1702.25c133.13-95.44,145.16-225.37,145.16-225.37",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 2534.44,
    y1: 1421.55,
    x2: 2422.96,
    y2: 2138.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-64",
    points: "2795.09 1330.92 2545.67 1403.9 2577.75 690.12 2832.81 662.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2839.2,555.39c-.8,0-258.25,28.87-258.25,28.87L2479.1,569",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2577.75,690.12l-92.23-18.44L2455,1379.84s24.06,20.05,90.63,24.06",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-64",
    points: "2402.11 1129.62 2393.29 1254.73 2457 1334.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-64",
    points: "2408.7 1273.98 2387.67 1287.61 2356.39 1287.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-64",
    points: "2387.27 1288.01 2454.64 1379.44 2248.13 1379.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2196,1254.73l36.09,97s-137.14,58.55-382.55,52.13-338.44-69.77-338.44-69.77-33.69-28.87,4.41-46.52",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1487.83,1355.78s56.94,57.74,352.08,65.77,381.75-11.23,392.17-16.85,19.25-20,16.05-34.48a25.55,25.55,0,0,0-16.05-18.45",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2238.9,1355.58l9.63-3.41a69,69,0,0,0,49.72,14.44c23-2.49,36.89-20,52.93-65.77S2417,1077.89,2425,1025c0,0,43.3-221.36,48.92-286.32s14.43-145.16,0-195.69",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2248.93,1351.77s36.89-20.85,84.21-164.41,95.44-351.27,102.65-406.61,28.88-160.4,19.25-243.81c-3.21-32.08-34.81-3.35-34.81-3.35",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1537,1564.9s48.3,97.66,149.94,133.54,320.58,27.87,320.58,27.87,163.77.8,198.9-28.07,85.26-66.39,122.83-157.11",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 1892.84,
    cy: 1336.93,
    rx: 272.68,
    ry: 49.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2257.21,1344.44s-14.7-90.51-38-112.17",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2276.4,1318.51s-11.43-49.35-27.47-76.61c-.8-39.3,31.71-223.54,44.91-278.3,16-66.56,104.26-365.71,139.55-421.05",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationToilettes);
export default __webpack_public_path__ + "static/media/situation_toilettes.88552da823e7bd74c1b7780f720aa836.svg";
export { ForwardRef as ReactComponent };